import { useState, useEffect } from "react";
import { STATUS } from "@/utils/enum";
import { getAvailableShipmentMarkers } from "@/services/shipments_new";

export function useGetShipmentMarkers() {
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(STATUS.IDLE);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      setStatus(STATUS.LOADING);
      try {
        const response = await getAvailableShipmentMarkers();
        if (isMounted) {
          setData(response);
          setStatus(STATUS.SUCCESS);
        }
      } catch (error) {
        if (isMounted) {
          setData([]);
          setStatus(STATUS.ERROR);
          setError(error);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    data,
    status,
    error,
    loading: [STATUS.IDLE, STATUS.LOADING].includes(status),
  };
}
